<template>
    <form action="submit">
        <input type="text">
        <form>
  <div class="form-group">
    <label for="exampleInputEmail1">Email address</label>
    <input type="email" v-bind="email" v-model="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
    <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
  </div>
  <div class="form-group">
    <label for="exampleInputPassword1">Password</label>
    <input type="password" :v-model="password" class="form-control" id="exampleInputPassword1" placeholder="Password">
  </div>
  <button type="submit" @click="storeInfo" class="btn btn-primary">Submit</button>
</form>
    </form>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password:''
    }
  },
  methods: {
    storeInfo() {
      this.email = email
      this.password = password
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Login.vue?3c3d28f6